export const replaceFileNameExtension = (fileName, extension) => `${fileName.replace(/\.[^.]+$/, '')}.${extension}`
